






































import Vue from 'vue';

import ShowReviewCardItem from './show-review-card-item.vue';

export default Vue.extend({
  name: 'ReviewCards',

  components: {
    ShowReviewCardItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    reviews: {
      type: Array,
      default: () => [],
    },

    rows: {
      type: Boolean,
      default: true,
    },
  },
});
